import { StyledGAIcon } from "./styles";

const GAIcon = ({
    isAvailable,
    isConnected,
    size = "xs",
}: {
    isConnected: boolean;
    isAvailable: boolean;
    size?: "xs" | "sm" | "lg";
}) => {
    const availableGA = isConnected ? (
        <StyledGAIcon
            iconName="ga-icon-active"
            size={size}
        />
    ) : (
        <StyledGAIcon
            iconName="ga-icon-disabled"
            size={size}
        />
    );

    return isAvailable ? (
        availableGA
    ) : (
        <StyledGAIcon
            iconName="ga-icon-locked"
            size={size}
        />
    );
};

export default GAIcon;
